import type { CpGpMatchedProduct } from '../../../../models/Coupang';
import type { GlowpickProduct } from '../../../../models/Glowpick';

export const combineMatchedProduct = (
  cpGpMatch: CpGpMatchedProduct | undefined,
  glowpickProductData: GlowpickProduct | undefined,
): CpGpMatchedProduct | undefined => {
  if (!cpGpMatch) {
    return undefined;
  }

  if (!glowpickProductData) {
    return cpGpMatch;
  }

  return {
    ...cpGpMatch,
    gpDetailedProduct: cpGpMatch.gpDetailedProduct
      ? {
          ...cpGpMatch.gpDetailedProduct,
          ...glowpickProductData,
        }
      : glowpickProductData,
  };
};
